import { AxiosPromise } from 'axios';
import { IVisitorDetailsFormValues } from '../types';
import { IVisitorQuestionnaireState } from './questinnaire';
import { IVisitorSignInCommand, VisitorQuestionnaireAnswers } from './types';
import { instance } from '../../../services';

const transformQuestionnaire = (
  questionnaire: IVisitorQuestionnaireState,
): VisitorQuestionnaireAnswers => {
  return questionnaire.sections.allIds.reduce(
    (sectionsObject: VisitorQuestionnaireAnswers, sectionId) => {
      sectionsObject[questionnaire.sections.byId[sectionId].heading] =
        questionnaire.sections.byId[sectionId].questions.map((questionId) => ({
          id: questionId,
          text: questionnaire.questions.byId[questionId].text,
          answeredYes:
            questionnaire.questions.byId[questionId].answer === 'yes',
          emailWhen: questionnaire.questions.byId[questionId].emailWhen,
          alert:
            questionnaire.questions.byId[questionId].answer === 'yes'
              ? questionnaire.questions.byId[questionId].yesMessage
              : questionnaire.questions.byId[questionId].noMessage,
        }));

      return sectionsObject;
    },
    {},
  );
};

const transform = (
  pin: string,
  visitorTypeId: number,
  details: IVisitorDetailsFormValues,
  questionnaire: IVisitorQuestionnaireState,
  agreementId: number | null,
  digitalSignature: string,
): IVisitorSignInCommand => ({
  pin,
  visitorTypeId,
  ...details,
  ...(questionnaire && {
    questionnaireAnswers: transformQuestionnaire(questionnaire),
  }),
  ...(agreementId && { visitorAgreementId: agreementId }),
  ...(digitalSignature && { digitalSignature }),
});

const attemptVisitorSignIn = (
  pin: string,
  visitorTypeId: number,
  details: IVisitorDetailsFormValues,
  questionnaire: IVisitorQuestionnaireState,
  agreementId: number | null,
  digitalSignature: string,
): AxiosPromise =>
  instance.post(
    'api/visitors/signIn',
    transform(
      pin,
      visitorTypeId,
      details,
      questionnaire,
      agreementId,
      digitalSignature,
    ),
  );

export default attemptVisitorSignIn;
